export const TRIP_REVIEW_HEADING_TEXT = "Trip review";
export const TRIP_REVIEW_SUBTITLE_TEXT =
  "Review your trip before you confirm and book.";
export const HOTEL_DETAILS_HEADING_TEXT = "Hotel details";
export const FLIGHT_DETAILS_HEADING_TEXT = "Flight details";
